import { render, staticRenderFns } from "./SelectionSection.vue?vue&type=template&id=5e3c1eca&scoped=true"
import script from "./SelectionSection.vue?vue&type=script&lang=js"
export * from "./SelectionSection.vue?vue&type=script&lang=js"
import style0 from "./SelectionSection.vue?vue&type=style&index=0&id=5e3c1eca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3c1eca",
  null
  
)

export default component.exports